module.exports = __webpack_public_path__ + "static/media/airconditioner_off.a748c29b.png";